// ─────────────────────────────────────────────────────────────────────────
// components/WeekCell.jsx
// Renders a table cell's "Week N" label plus an optional IA/Mock/AU
// badge on the line below. Same named export/props as the original.
// ─────────────────────────────────────────────────────────────────────────

import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { C } from "../constants/colors";

export const WeekCell = ({ value }) => {
  const parts = String(value ?? "").split("\n");
  const weekLabel = parts[0];
  const badge = parts[1] || null;

  const badgeStyle = () => {
    if (!badge) return null;
    if (badge.includes("IA")) return { bg: C.warningBg, color: C.warning };
    if (badge.includes("Mock")) return { bg: C.errorBg, color: C.error };
    if (badge.includes("AU")) return { bg: C.dtPurpleBg, color: C.dtPurple };
    return null;
  };

  const bs = badgeStyle();

  return (
    <Box>
      <Typography sx={{ fontWeight: 700, fontSize: 13, color: C.text }}>{weekLabel}</Typography>
      {badge && bs && (
        <Chip
          label={badge.replace(/^[🟠🔵🔴]\s*/, "")}
          size="small"
          sx={{
            mt: 0.5, height: 18, fontSize: 10, fontWeight: 700,
            background: bs.bg, color: bs.color, "& .MuiChip-label": { px: 1 },
          }}
        />
      )}
    </Box>
  );
};
